import { Header } from "./Header";
import { Footer } from "./Footer";
import { LaunchBanner } from "@/components/LaunchBanner";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <LaunchBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
